<template>
  <div class="absolute inset-0 flex items-center justify-center text-white text-xl font-bold">
    {{ countdownValue }}
  </div>
</template>

<script>
export default {
  name: 'ButtonCountdown',
  props: {
    countdownValue: {
      type: Number,
    },
  },
};
</script>
